import { IssueReportOnView } from './common';
import { isPlainObject } from 'shared/utils/object';

export function isIssueReportOnView(values: unknown): values is IssueReportOnView {
  if (!isPlainObject(values)) {
    return false;
  }

  return (
    'fieldsContent' in values
    && 'selectedFields' in values
    && 'linkedDocumentation' in values
  );
}
